import React from "react"
import PropTypes from "prop-types"
import Card from "@mui/material/Card"
import Grid from "@mui/material/Grid"
import Icon from "@mui/material/Icon"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import Circle from "components/Circle"
import { Badge } from "@mui/material"
import { setOpenConfigurator } from "context"
import { setConfiguratorPage } from "context"
import { useMaterialUIController } from "context"

function DeviceStatisticsCard({ color = "info", title, dataDate, count, percentage, icon }) {
  const handleConfiguratorOpen = () => {
    setConfiguratorPage(dispatch, "devices")
    setOpenConfigurator(dispatch, true)
  }
  const [controller, dispatch] = useMaterialUIController()
  const { openConfigurator } = controller

  return (
    <Card>
      <MDBox display="flex" justifyContent="space-between" pt={1} px={2}>
        <MDBox
          variant="gradient"
          bgColor={color}
          color={color === "light" ? "dark" : "white"}
          coloredShadow={color}
          borderRadius="xl"
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="4rem"
          height="4rem"
          mt={-3}
        >
          {icon && (
            <Icon fontSize="medium" color="inherit">
              {icon}
            </Icon>
          )}
        </MDBox>
        <MDBox textAlign="right" lineHeight={1} p={1}>
          <Grid container>
            <Grid item xs={12}>
              <MDTypography sx={{ textAlign: "center" }} variant="h6" fontWeight="light">
                {title}
              </MDTypography>
              <MDTypography sx={{ textAlign: "center" }} fontWeight="light" fontSize="12px">
                {dataDate || ""}
              </MDTypography>
            </Grid>
          </Grid>
          <MDTypography variant="h4">{count}</MDTypography>
        </MDBox>
      </MDBox>
      <MDBox pb={1} px={2}>
        <MDTypography
          component="h6"
          variant="body2"
          display="flex"
          mb={2}
          onClick={handleConfiguratorOpen}
          sx={{ cursor: "pointer" }}
        >
          {percentage.label}
        </MDTypography>
        <MDTypography component="p" variant="button" display="flex" alignItems="center" gap={1}>
          <Badge color="warning"></Badge>
          <Circle color="success.main" />
          {percentage.amountOnline} Online
          <Circle color="error.main" />
          {percentage.amountOffline} Offline
        </MDTypography>
      </MDBox>
    </Card>
  )
}

// Setting default values for the props of ComplexStatisticsCard
DeviceStatisticsCard.defaultProps = {
  color: "info",
  title: "",
  dataDate: "",
  count: 0,
  filter: false,
  percentage: {
    color: "info",
    amountOnline: 0,
    amountOffline: 0,
    label: "",
  },
  icon: "info",
  filterClick: () => {},
}

// Typechecking props for the ComplexStatisticsCard
DeviceStatisticsCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  title: PropTypes.string.isRequired,
  dataDate: PropTypes.string,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  filter: PropTypes.bool,
  percentage: PropTypes.shape({
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "white",
    ]),
    amountOnline: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    amountOffline: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
  }),
  icon: PropTypes.node,
  filterClick: PropTypes.func,
}

export default DeviceStatisticsCard
